import Loader from "loader";
import React from "react";
import "./GlobalLoadScreen.scss";

const GlobalLoadScreen = (props) => (
  <div className="global-loading"><Loader></Loader></div>
);
export default GlobalLoadScreen;
